<template>
  <div
    class="flex flex-wrap lg:gap-4 bg-white md:rounded-3xl items-center shadow-combined-elevation-3 p-4 md:py-6 md:px-8"
    :data-testid="dataTestid"
  >
    <span
      v-if="$slots.label"
      class="text-semantic-surface-on-surface text-semantic-sizing-label-lg font-bold">
      <slot name="label">
        {{ label }}
      </slot>
    </span>

    <slot />
  </div>
</template>

<script setup>
defineOptions({
  name: 'V2MoleculesAuthorFeaturePanel'
})

defineProps({
  dataTestid: {
    type: String,
    default: 'author-feature-panel'
  },

  label: {
    type: String,
    default: ''
  }
})
</script>
